const { COMMERCE_HEADER } = require('../constants');
const { getChannelId, getXCommerceValue } = require('../lib/browserData');
const { getEcommId } = require('../lib/browserData');

const http = require('../lib/httpClient');

const endpoint = '/v1/validate';
const service = '/s/auth';
// eslint-disable-next-line default-param-last
async function agentAuthValidate(agentBaseUrl = '', sessionId, tenantId, channel) {
  const result = await http.post(
    `${agentBaseUrl || service}${endpoint}`,
    { sessionId },
    {
      headers: {
        'x-channel-id': getChannelId(channel),
        'x-ecomm-name': getEcommId(tenantId),
        'x-commerce': getXCommerceValue(agentBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) {
    return { active: false };
  }
  return responseBody;
}

module.exports = agentAuthValidate;
